import React, {Component} from 'react';
import '../styles/ProfileView.css';

class ProfileView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            data: []
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(JSON.stringify(nextProps.data) !== JSON.stringify(prevState.data)) {
            return {
                data: nextProps.data
            }
        }
        return null
    }
    
    render() {
        const { data } = this.state
        
        return (
            <div className="view-profile">
                <div className="container-left full-height">
                    <div className="square-wrapper">
                        <div className="value">{data[0] ? data[0].value : ''}</div>
                        <div className="label">{data[0] ? data[0].label : ''}</div>
                    </div>
                </div>
                <div className="container-middle full-height">
                    <div className="square-wrapper">
                        <div className="value">{data[1] ? data[1].value : ''}</div>
                        <div className="label">{data[1] ? data[1].label : ''}</div>
                    </div>
                </div>
                <div className="container-right full-height">
                    <div className="square-wrapper">
                        <div className="value">{data[2] ? data[2].value : ''}</div>
                        <div className="label">{data[2] ? data[2].label : ''}</div>
                    </div>
                </div>
            </div>
        )

    }
}

export default ProfileView;


// WEBPACK FOOTER //
// ./src/components/ProfileView.js